import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function AdminClients() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/clients").then((r) => setItems(r.data)); }, []);

  return (
    <div>
      <div className="mb-8">
        <p className="overline">Comunidad</p>
        <h1 className="font-display text-4xl font-light tracking-tight mt-3">Clientes</h1>
      </div>

      <Card className="border-slate-200">
        <CardContent className="p-0">
          <Table data-testid="clients-table">
            <TableHeader>
              <TableRow>
                <TableHead>Nombre</TableHead>
                <TableHead>Correo</TableHead>
                <TableHead>Teléfono</TableHead>
                <TableHead>Origen</TableHead>
                <TableHead>Última cita</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {items.length === 0 ? (
                <TableRow><TableCell colSpan={5} className="text-center text-slate-500 py-12">Aún no hay clientes registrados</TableCell></TableRow>
              ) : items.map((c) => (
                <TableRow key={c.id} data-testid={`client-row-${c.id}`}>
                  <TableCell className="font-medium">{c.name || "—"}</TableCell>
                  <TableCell>{c.email}</TableCell>
                  <TableCell className="text-slate-500">{c.phone || "—"}</TableCell>
                  <TableCell>
                    {c.source === "guest" ? (
                      <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-sky-50 text-sky-700 text-xs border border-sky-200">Reserva</span>
                    ) : (
                      <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 text-xs border border-emerald-200">Cuenta</span>
                    )}
                  </TableCell>
                  <TableCell className="text-slate-500 text-sm">{(c.last_appointment_at || c.created_at)?.slice(0,10) || "—"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
